import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Observable,
  catchError,
  from,
  mergeMap,
  of,
  tap,
  throwError,
} from 'rxjs';
import { SafetyControlOfflineRuntimeService } from '../pages/ssa/safety-control/services/safety-control-offline-runtime.service';

@Injectable()
export class SafetyControlOfflineCacheInterceptor implements HttpInterceptor {
  constructor(private offline: SafetyControlOfflineRuntimeService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (
      request.method !== 'GET' ||
      !request.url.includes('/recursos-humanos/ssa/safety-control')
    ) {
      return next.handle(request);
    }

    if (!this.offline.isOnline()) {
      return this.fromCache(request);
    }

    return next.handle(request).pipe(
      tap((event) => {
        if (event instanceof HttpResponse && event.ok) {
          void this.offline.cacheResponse(request.urlWithParams, event.body);
        }
      }),
      catchError((error: any) => {
        if (error?.status !== 0) return throwError(() => error);
        return this.fromCache(request, error);
      }),
    );
  }

  private fromCache(
    request: HttpRequest<any>,
    originalError?: any,
  ): Observable<HttpEvent<any>> {
    return from(this.offline.getCachedResponse(request.urlWithParams)).pipe(
      mergeMap((cached) => {
        if (cached) {
          return of(
            new HttpResponse({
              body: cached.body,
              status: 200,
              statusText: 'OK (offline)',
              url: request.urlWithParams,
            }),
          );
        }

        return throwError(
          () =>
            originalError ||
            new HttpErrorResponse({
              status: 0,
              statusText: 'OFFLINE_CACHE_MISS',
              url: request.urlWithParams,
              error: {
                message:
                  'Sin conexión y sin copia local para esta consulta de Control de Seguridad.',
              },
            }),
        );
      }),
    );
  }
}
